import TreeNode from "./TreeNode";

export default class TreeRootNode extends TreeNode {
    constructor() {
        super();
        this.idMap = {};
    }

    getParent() {
        return null;
    }

    setParent() {
    }

    getRoot() {
        return this;
    }

    getNodeById(id) {
        return this.idMap[id];
    }

    _childAdded(treeNode) {
        this.idMap[treeNode.getId()] = treeNode;
    }
}


// WEBPACK FOOTER //
// ./web/js/hierarchySelector/tree/TreeRootNode.js